// extracted by mini-css-extract-plugin
export default {"input":"TreatmentPage_input__SyBb1"};